import { Component, Input, OnInit, Renderer2 } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService, RESTClientConfig } from 'rest-client';

import { LANG_STORAGE } from '@shared/const/cookies.consts';
import { UserService } from '@core/services/user/user.service';

@Component({
  selector: 'bkg-language-selector',
  templateUrl: './language-selector.component.html',
})
export class LanguageSelectorComponent implements OnInit {
  @Input() erpMode: boolean;

  constructor(
    private translateService: TranslateService,
    private restClientConfig: RESTClientConfig,
    private renderer: Renderer2,
    private userService: UserService,
    private authService: AuthenticationService
  ) {}

  headerLanguages: string[];
  selectedLang: string;

  setLanguage(lang: string): void {
    this.restClientConfig.setLang(lang);
    this.translateService.use(lang);
    this.selectedLang = lang;
    localStorage.setItem(LANG_STORAGE, lang);
    this.renderer.setAttribute(document.querySelector('html'), 'lang', lang);
    if(this.authService.isTokenValid() && this.authService.isClient()) {
      this.userService.setForcedLang(lang);
    }
  }

  ngOnInit(): void {
    this.getDefaultLang();
    this.getLanguages();
  }

  private getLanguages(): void {
    this.headerLanguages = this.translateService.getLangs();
  }

  private getDefaultLang(): void {
    this.selectedLang = this.translateService.getDefaultLang();
    this.renderer.setAttribute(
      document.querySelector('html'),
      'lang',
      this.selectedLang
    );
  }
}
